(() => {
  "use strict";
  if (!window.Lymko || window.__lk_pages) return;
  window.__lk_pages = 1;
  const { $, $$, reduced, esc, money, toast, addItems, openO, closeAll, reveal, markFavs, store, R, CFG } = window.Lymko;
  function ingredients() {
    const az = $("#az");
    if (!az) return;
    az.addEventListener("click", (e) => {
      const b = e.target.closest("[data-az]");
      if (!b) return;
      $$("#az button").forEach((x) => x.classList.toggle("on", x === b));
      $$("#ig .igc").forEach((c) => c.style.display = b.dataset.az === "all" || c.dataset.t === b.dataset.az ? "" : "none");
    });
    let h = "";
    try {
      h = decodeURIComponent(location.hash.slice(1));
    } catch (e) {
      h = location.hash.slice(1);
    }
    const el = h && document.getElementById(h);
    if (el) setTimeout(() => {
      el.scrollIntoView({ block: "center", behavior: reduced ? "auto" : "smooth" });
      el.style.borderColor = "var(--or)";
      el.style.boxShadow = "0 0 0 4px var(--orsoft)";
    }, 350);
  }
  function toc() {
    const t = $("#toc"), b = $("#artbody");
    if (!t || !b) return;
    const hs = $$("h2", b);
    if (hs.length < 2) return;
    hs.forEach((h, i) => {
      if (!h.id) h.id = "s" + (i + 1);
      t.insertAdjacentHTML("beforeend", `<a href="#${h.id}">${esc(h.textContent)}</a>`);
    });
    t.hidden = false;
  }
  /* LK-BLOG-FILTER (2026-10-20): journal chips filter by topic (data-topics, built from each article's tags, category
     and title in sections/main-blog.liquid). The featured article steps aside while a topic is chosen and appears in
     the grid when it matches; the choice is kept in the address (?topic=…) for Back / shared links.
     Older cards without data-topics still match by their category (data-cat). */
  function journalChips() {
    const j = $("#jcats");
    if (!j || j.dataset.lkBound) return;
    j.dataset.lkBound = 1;
    const grid = $("#jgrid"), feat = $("#jfeat"), empty = $("#jempty");
    const chips = $$("[data-jc]", j);
    const match = (p, k) => {
      const t = p.dataset.topics;
      if (t) return t.indexOf("|" + k + "|") > -1;
      return (p.dataset.cat || "") === k;
    };
    const apply = (k, keepUrl) => {
      let b = chips.find((x) => x.dataset.jc === k);
      if (!b) { b = chips[0]; k = "all"; }
      chips.forEach((x) => {
        x.classList.toggle("on", x === b);
        x.setAttribute("aria-pressed", x === b);
      });
      const all = k === "all";
      let n = 0;
      $$(".post", grid).forEach((p) => {
        const dup = p.classList.contains("lk-fdup");
        const show = all ? !dup : match(p, k);
        p.hidden = !show;
        if (show) { n++; p.classList.add("in"); }
      });
      if (feat) feat.hidden = !all;
      if (empty) empty.hidden = all || n > 0;
      if (!keepUrl) {
        try {
          const u = new URL(location.href);
          if (all) u.searchParams.delete("topic"); else u.searchParams.set("topic", k);
          history.replaceState(history.state, "", u);
        } catch (e) {}
      }
      if (!all && b.scrollIntoView && j.scrollWidth > j.clientWidth + 2) {
        const jr = j.getBoundingClientRect(), br = b.getBoundingClientRect();
        if (br.left < jr.left || br.right > jr.right) j.scrollBy({ left: br.left + br.width / 2 - (jr.left + jr.width / 2), behavior: reduced ? "auto" : "smooth" });
      }
    };
    j.addEventListener("click", (e) => {
      const b = e.target.closest("[data-jc]");
      if (b) apply(b.dataset.jc);
    });
    let k0 = "";
    try { k0 = new URL(location.href).searchParams.get("topic") || ""; } catch (e) {}
    if (k0) apply(k0, true);
  }
  const init = () => {
    ingredients();
    toc();
    journalChips();
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
  document.addEventListener("shopify:section:load", init);
})();
